import { useQuery } from '@tanstack/react-query';

import { getTimeOffTypes } from '@/modules/settings/api/time-offs.api';
import { TimeOffTypeCode } from '@/modules/settings/types/time-off';

import { TIME_OFF_QUERY_KEY_ROOT } from '../constants/time-offs-query-keys';

const TIME_OFF_TYPE_OPTIONS_QUERY_KEY = [TIME_OFF_QUERY_KEY_ROOT, 'type-options'];

export interface TimeOffTypeOption {
  value: string;
  label: string;
}

/**
 * Selectable time-off categories for the create form. Sourced from the settings
 * types endpoint; public holidays are excluded (system-managed, not requestable).
 */
export const useTimeOffTypeOptions = (enabled = true) =>
  useQuery({
    queryKey: TIME_OFF_TYPE_OPTIONS_QUERY_KEY,
    queryFn: async (): Promise<TimeOffTypeOption[]> => {
      const types = await getTimeOffTypes();
      return types
        .filter(type => type.code !== TimeOffTypeCode.PUBLIC_HOLIDAY)
        .map(type => ({ value: String(type.id), label: type.displayName }));
    },
    enabled,
  });
